import type { VFC } from 'react';
import { Row, Col } from 'antd';
import { RowGutter } from 'common/spacing';
import type { ResellersTab } from 'routes/resellers/enums/resellersTab';
import { ResellerTrialCreditsTable } from './components/Table';

export const TrialCredits: VFC<{ id: ResellersTab }> = () => (
  <Row gutter={[RowGutter.Default, RowGutter.Default]}>
    <Col span={24}>
      <ResellerTrialCreditsTable />
    </Col>
  </Row>
);
